import { useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useTeam } from '../contexts/TeamContext';

export function useSupabaseTeam() {
  const { setTeamMembers } = useTeam();

  useEffect(() => {
    if (!supabase) return;

    // Fetch team members from Supabase
    const fetchTeamMembers = async () => {
      const { data, error } = await supabase
        .from('team_members')
        .select('*')
        .order('name', { ascending: true });

      if (error) {
        console.error('Error fetching team members:', error);
        return;
      }

      if (data) {
        const formattedMembers = data.map((m: any) => ({
          id: m.id,
          name: m.name,
          email: m.email,
          role: m.role,
          status: m.status,
          currentProjectId: m.current_project_id,
          projectsCount: m.projects_count || 0,
          createdAt: m.created_at,
        }));
        
        setTeamMembers(formattedMembers);
      }
    };

    fetchTeamMembers();

    // Subscribe to changes
    const subscription = supabase
      .channel('team-members-changes')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'team_members' }, () => {
        fetchTeamMembers();
      })
      .subscribe();

    return () => {
      subscription.unsubscribe();
    };
  }, [setTeamMembers]);
}





